
export default {
    computed: {
        terms: {
            get() {
                return this.$store.state.terms;
            },
            set(val) {
                this.$store.commit('setTerms', val)
            }
        },

        termsAgreements: {
            get() {
                return this.$store.state.termsAgreements;
            },
            set(val) {
                this.$store.commit('setTermsAgreements', val)
            }
        },
    },

    methods: {
        async findTerm(termsId) {
            if (!termsId) {
                return;
            }

            const res = await this.$axios.get(`/v1/home/terms/findTerm/${termsId}`);
            return res.data;
        },

        async availableTerms() {
            const res = await this.$axios.get('/v1/home/terms/availableTerms', {
                params: {
                    termsType: "BASIC"
                }
            });
            return res.data;
        },

        async isAgreeTerms() {
            const terms = await this.availableTerms();
            const requiredTerms = terms
                .filter(term => term.requiredYn === 'Y' && term.isLink === 'N')
                .map(term => term.termsId);

            if (requiredTerms.length === 0) {
                return true;
            }

            return requiredTerms
                .reduce((prev, termsId) => {
                    return prev && this.termsAgreements.includes(termsId)
            }, true);
        },

    }

}